module.exports = __webpack_public_path__ + "static/media/zoomy3_preview.ff8c31fe.jpg";